import { localization } from "../localizationManager";

export var swedishStrings = {
  groupButton: "Gruppera av mig",
  ungroupButton: "Avgruppera av mig",
  selectButton: "Välj mig",
  hideColumn: "Göm kolumn",
  showColumn: "Visa kolumn",
  makePrivateColumn: "Gör kolumn privat",
  makePublicColumn: "Gör kolumn offentlig",
  moveToDetail: "Flytta till detalj",
  showAsColumn: "Visa som kolumn",
  filterPlaceholder: "Sök...",
  removeRows: "Ta bort rader",
  showLabel: "Visa",
  entriesLabel: "poster",
  visualizer_text: "Texter i tabell",
  visualizer_wordcloud: "Ordmoln",
  visualizer_histogram: "Histogram",
  visualizer_number: "Genomsnitt",
  visualizer_choices: "Tabell",
  visualizer_selectBase: "Diagram",
  visualizer_matrix: "Diagram",
  chartType_bar: "Stapel",
  chartType_vbar: "Vertikal stapel",
  chartType_stackedbar: "Staplad stapel",
  chartType_doughnut: "Ring",
  chartType_pie: "Cirkel",
  chartType_scatter: "Punkt",
  chartType_gauge: "Mätare",
  chartType_bullet: "Bullet",
  chartType_line: "Linje",
  chartType_radar: "Radar",
  hideButton: "Göm",
  makePrivateButton: "Gör privat",
  makePublicButton: "Gör offentlig",
  showButton: "Visa",
  filter: "Filter",
  resetFilter: "Återställ filter",
  changeLocale: "Ändra språk",
  clearButton: "Rensa",
  addElement: "Välj fråga att visa...",
  defaultOrder: "Standard ordning",
  ascOrder: "Stigande",
  descOrder: "Fallande",
  showMinorColumns: "Visa mindre kolumner",
  actionsColumn: "Åtgärder",
  otherCommentTitle: "Övriga objekt och kommentarer",
  showPercentages: "Visa procent",
  hidePercentages: "Göm procent",
  pdfDownloadCaption: "PDF",
  xlsxDownloadCaption: "Excel",
  csvDownloadCaption: "CSV",
  saveDiagramAsPNG: "Ladda ner diagram som PNG-fil",
  hideEmptyAnswers: "Göm tomma svar",
  showEmptyAnswers: "Visa tomma svar",
  "topNValueText-1": "Alla svar",
  topNValueText5: "Topp 5 svar",
  topNValueText10: "Topp 10 svar",
  topNValueText20: "Topp 20 svar",
  hideMissingAnswers: "Göm saknade svar",
  showMissingAnswers: "Visa saknade svar",
  missingAnswersLabel: "Saknade svar",
  noVisualizerForQuestion: "Detta frågetyp är inte visualiserad ännu",
  noResults: "Det finns inga resultat ännu",
  showPerValues: "Per värden",
  showPerColumns: "Per kolumner",
  answer: "Svar",
  correctAnswer: "Rätt svar: ",
  percent: "Procent",
  percentage: "Procent",
  statistics_chart: "Diagram",
  responses: "Svar",
  visualizer_nps: "NPS",
  npsScore: "NPS",
  npsPromoters: "Promotorer",
  npsPassives: "Passiva",
  npsDetractors: "Kritiker",
  axisXSelectorTitle: "X-axel:",
  axisYSelectorTitle: "Y-axel:",
};

localization.locales["sv"] = swedishStrings;
localization.localeNames["sv"] = "Svenska";
